import React, { PureComponent } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { PrimaryButton } from 'appSrc/components/UI';
import { complexUpdateProductModal } from 'appSrc/redux/actions/productModalManager';
import style from './styles/style.module.css';

import SelectionOptionCard from './OptionCard';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';

import closeIcon from 'appSrc/assets/img/close.svg';

class ProductSelectionModal  extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    componentDidUpdate( prevProps ) {
        if( prevProps.isOpen != this.props.isOpen && this.state.fetching ) {
            this.setState( { fetching: false } );
        }
    }
    selectCard = () => {
        this.setState( { fetching: true } );
        var selectedProduct;
        var selection = this._options.querySelector( '[name="selectedProduct"]:checked' ).value;
        if( selection == 'scraped' ) {
            selectedProduct = this.props.product.scraped || {};
        } else {
            selectedProduct = this.props.product.options[ selection ];
        }
        this.props.dispatch( complexUpdateProductModal( {
            showModal: 'detailsModal',
            product: selectedProduct,
        } ) );
        this.setState( { fetching: false } );
    }
    render() {
        const { isOpen, product } = this.props;
        const scraped = product.scraped || {};
        var options = product.options || [];
        if( options.length !== undefined ) {
            options.slice( 0, 9 );
        }
        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel="Add Product"
            onRequestClose={ this.props.closeModal }
            className={ `modal-popup ${ style.selectionModal }` }
            overlayClassName='modal-overlay'
            >
                { this.state.fetching &&
                    <LoadingOverlay />
                }
                <div className={style.title}>
                    Click to select product
                </div>
                <div className={style.close}>
                    <img src={closeIcon} onClick={ this.props.closeModal } />
                </div>
                <div className={ style.selectionModalContent }>
                    <div className={ style.options } ref={ ( el ) => { this._options = el; } }>
                        <SelectionOptionCard
                            product={ scraped }
                            error='*no commision earned'
                            value='scraped'
                            defaultChecked />
                        { options.map( ( item, index ) => {
                            return (
                                <SelectionOptionCard
                                    product={ item }
                                    key={ index }
                                    value={ index } />
                            );
                        } ) }
                    </div>
                    <div className={ style.buttonGroup }>
                        <PrimaryButton
                        label="Select"
                        onClick={ this.selectCard } />
                    </div>
                </div>
            </ReactModal>
        );
    }
}
ProductSelectionModal.defaultProps = {
    isOpen: false,
    product: { scraped: {}, options: [] },
};

export default connect()( ProductSelectionModal );
